var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.getTag(),{tag:"component",class:[
    'fd-text mb-0 flex-shrink-0 font-weight-normal',
    { 'fd-text--fa': _vm.fa },
    { 'fd-text--font-size-unset': _vm.isTagPre },
    _vm.getTextAlignClasses(),
    _vm.getTextBehaviourClasses(),
    _vm.getTextColorClasses(),
    _vm.getTextDecorationClasses(),
    _vm.getTextFontFamily(),
    _vm.getTextSizeClasses(),
    _vm.getTextStyleClasses(),
    _vm.getTextTransformationClasses(),
    _vm.getTextWeightClasses(),
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }